import { Injectable, OnDestroy } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable, of, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthModel } from "../models/auth.model";
export type User = AuthModel | undefined;
const API_USERS_URL = `${environment.apiUrl}`;

@Injectable({
  providedIn: "root",
})
export class AuthService implements OnDestroy{

  private authLocalStorageToken = `user`;

  public unsubscribe: Subscription[] = [];

  // public fields
  currentUser$: Observable<User>;
  isLoading$: Observable<boolean>;
  currentUserSubject: BehaviorSubject<User>;

  get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  set currentUserValue(user: User) {
    this.currentUserSubject.next(user);
  }
  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(undefined);
    this.currentUser$ = this.currentUserSubject.asObservable();
  }



  login(email: String, password: String): Observable<any> {
   
    return this.http.post<AuthModel>(`${API_USERS_URL}/login`, {
      email,
      password,
    });
  }


  register(name: string, email: string, password: string, password_confirmation: string) {
    return this.http
      .post<any>(`${environment.apiUrl}/register`, {
        name,
        email,
        password,
        password_confirmation
      })
      .pipe(
        map((user) => {

          localStorage.setItem("currentUser", JSON.stringify(user));
          this.currentUserSubject.next(user);
          return user;
        })
      );
  }

  forgotPassword(email: string) {
    return this.http
      .post<any>(`${environment.apiUrl}/forgot-password`, {
        email
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  resetPassword(password: string, password_confirmation: String, token: String, email: String) {
    return this.http
      .post<any>(`${environment.apiUrl}/reset-password`, {
        password,
        password_confirmation,
        token,
        email
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  changePassword(password: string,new_password:string,token:string,email:string ): Observable<any> {

    var formData: any = new FormData();
    formData.append("password", password);
    formData.append("password_confirmation", new_password);

    return this.http.post<any>(`${API_USERS_URL}/change-password`,formData,{
      params:{
      token:token,
      email:email
      }
    });
  }

  logout() {

  
    const auth = this.getAuthFromLocalStorage();
        if (!auth || !auth.token) {
          return of(undefined);
        }
    
        return this.http.post<any>(`${API_USERS_URL}/logout`,'',
        {
          headers: new HttpHeaders({
      
            'Authorization': 'Bearer ' + auth.token,
      
            'Accept': 'application/json'
      
          })
      
        });
    
      }
    

  getUserByToken() {

    if(localStorage.getItem(this.authLocalStorageToken)!=null){
     
     
     const auth = this.getAuthFromLocalStorage();
     if (!auth || !auth.token) {
       return of(undefined);
     }
 
     
 
     if (auth) {
 
       this.currentUserSubject.next(auth);
 
      const user= this.currentUserSubject.subscribe((res)=>{
 
        return res;
 
       })
 
        this.unsubscribe.push(user)
    
 
 
      
     } else {
 
       this.currentUserSubject.unsubscribe();
 
 
       this.logout().subscribe(()=>{
 
         localStorage.removeItem(this.authLocalStorageToken);
   
        
   
 
       },(err)=>{
         
         console.log(err)
   
       });
     }
   
   }else{
   
    
   }
   }
 
  getUserByTokens() {
   const user = this.getAuthFromLocalStorage();
   if (!user || !user.token) {
     return of(undefined);
   }
 
     if (user) {
         this.currentUserSubject.next(user);
 
       } else {
         this.logout();
 
       }
       return user;
 
   
 }


  // private methods
  public setAuthFromLocalStorage(auth: AuthModel): boolean {
    // store auth authToken/refreshToken/epiresIn in local storage to keep user logged in between page refreshes
    //eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xMjcuMC4wLjE6MTAwMFwvYXBpXC9sb2dpbiIsImlhdCI6MTYzOTQ1ODU5MCwiZXhwIjoxNjM5NDYyMTkwLCJuYmYiOjE2Mzk0NTg1OTAsImp0aSI6IjhNbjlsdUZuNEtNRFpNb1ciLCJzdWIiOjMsInBydiI6ImEzNGY0ODg3NDdjNDFmMWQxYTAzNTU4NDE2NjNmYWYxOTI3MDNhMmIifQ.sjdBBYfHZ-B-ErUeJH8iiOwDYuhoRt_rv3nq6N8EBps
   //    localStorage.setItem(this.authLocalStorageToken, JSON.stringify("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xMjcuMC4wLjE6MTAwMFwvYXBpXC9sb2dpbiIsImlhdCI6MTYzOTQ1ODU5MCwiZXhwIjoxNjM5NDYyMTkwLCJuYmYiOjE2Mzk0NTg1OTAsImp0aSI6IjhNbjlsdUZuNEtNRFpNb1ciLCJzdWIiOjMsInBydiI6ImEzNGY0ODg3NDdjNDFmMWQxYTAzNTU4NDE2NjNmYWYxOTI3MDNhMmIifQ.sjdBBYfHZ-B-ErUeJH8iiOwDYuhoRt_rv3nq6N8EBps"));

    if (auth && auth.token) {

     localStorage.setItem(this.authLocalStorageToken, JSON.stringify(auth));
      return true;
    }
    return false;
  }
    public getAuthFromLocalStorage(): AuthModel | undefined {
      try {
        const lsValue = localStorage.getItem(this.authLocalStorageToken);
        if (!lsValue) {
          return undefined;
        }
  
        const authData = JSON.parse(lsValue);
        return authData;
      } catch (error) {
        console.log(error);
        return undefined;
      }
    }

    refreshToken(): Observable<any> {

      const auth = this.getAuthFromLocalStorage();
      if (!auth || !auth.token) {
        return of(undefined);
      }
      console.log(auth.token)
  
      return this.http.post<any>(`${API_USERS_URL}/customer/refresh`,
      {
        headers: new HttpHeaders({
    
          'Authorization': 'Bearer ' +auth.token,
    
          'Accept': 'application/json'
    
        })
    
      });
    }
  
  
    ngOnDestroy() {
      this.unsubscribe.forEach((sb) => sb.unsubscribe());
    }
}
